export default __webpack_public_path__ + "static/tidyverse-8c5c626d96cf309447d3abd7c05e06fb.png";